export default "__VITE_ASSET__isyrrmzD__"